import { RepoProviderIcon } from '@/shared/components/RepoProviderIcon'
import { repoHost } from '@/features/providers/lib/versions'

/** Only render a source_url as a link when it is a safe https VCS/repo URL — icon-only (the host
 *  is carried in the `title` attribute for hover/accessibility, not printed inline). */
export function SourceLink({ url }: { url: string | null }) {
  if (!url) return <span className="dim">—</span>
  let host: string
  try {
    const u = new URL(url)
    if (u.protocol !== 'https:') throw new Error('scheme')
    host = u.hostname + u.pathname.replace(/\/$/, '')
  } catch {
    return <span style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text3)' }}>{url}</span>
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title={host} style={{ display: 'inline-flex', alignItems: 'center' }}>
      <RepoProviderIcon provider={repoHost(url)} />
    </a>
  )
}
